<div class="lum-rfq-table-form">
  <form [formGroup]="form">
    <div class="table__container">
      <table class="lum-table lum-table--classic striped">
        <thead>
          <tr class="table__head-row">
            <th>
              <mat-checkbox
                [formControl]="selectAll"
                (click)="onSelectAll()"
                class="lum-checkbox"
              ></mat-checkbox>
            </th>
            <th></th>
            <th
              *ngIf="displayColumns['sku'].visible"
              (click)="onConfirmSort('sku')"
              class="cursor-pointer"
            >
              <b>{{ displayColumns['sku'].label }}</b>
              <span *ngIf="sortState.column === 'sku'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['product_name'].visible"
              (click)="onConfirmSort('product_name')"
              class="cursor-pointer"
            >
              <b>{{ displayColumns['product_name'].label }}</b>
              <span *ngIf="sortState.column === 'product_name'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['description'].visible"
              (click)="onConfirmSort('description')"
              class="cursor-pointer"
            >
              <b>{{ displayColumns['description'].label }}</b>
              <span *ngIf="sortState.column === 'description'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['category'].visible"
              (click)="onConfirmSort('category')"
              class="cursor-pointer min-w-35"
            >
              <b>{{ displayColumns['category'].label }}</b>
              <span *ngIf="sortState.column === 'category'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['sub_category'].visible"
              (click)="onConfirmSort('subcategory')"
              class="min-w-35 cursor-pointer"
            >
              <b>{{ displayColumns['sub_category'].label }}</b>
              <span *ngIf="sortState.column === 'subcategory'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['stock'].visible"
              (click)="onConfirmSort('location_stock')"
              class="cursor-pointer"
            >
              <b>{{ displayColumns['stock'].label }}</b>
              <span *ngIf="sortState.column === 'location_stock'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['quantity'].visible"
              (click)="onConfirmSort('quantity')"
              class="w-45 text-right pr-5 cursor-pointer"
            >
              <b>{{ displayColumns['quantity'].label }}</b>
              <span *ngIf="sortState.column === 'quantity'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['unit'].visible"
              (click)="onConfirmSort('ordered_uom_id')"
              class="w-50 cursor-pointer"
            >
              <b>{{ displayColumns['unit'].label }}</b>
              <span *ngIf="sortState.column === 'ordered_uom_id'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngIf="displayColumns['unit_price'].visible"
              (click)="onConfirmSort('unit_price')"
              class="w-45 text-right pr-5 cursor-pointer"
            >
              <b>{{ fromTransferOrder ? 'Unit Cost' : 'Unit Price' }}</b>
              <span *ngIf="sortState.column === 'unit_price'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              (click)="onConfirmSort('discount_amount')"
              *ngIf="isOverride"
              class="w-45 text-right cursor-pointer"
            >
              <b>Discount $</b>
              <span *ngIf="sortState.column === 'discount_amount'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              (click)="onConfirmSort('discount_percent')"
              *ngIf="isOverride"
              class="w-45 text-right cursor-pointer"
            >
              <b>Discount %</b>
              <span *ngIf="sortState.column === 'discount_percent'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th
              (click)="onConfirmSort('net_total_amount')"
              class="text-right cursor-pointer"
            >
              <b>Line Total</b>
              <span *ngIf="sortState.column === 'net_total_amount'">
                {{ sortState.direction === 'asc' ? '↑' : '↓' }}
              </span>
            </th>
            <th *ngIf="displayColumns['line_total'].visible" class="text-right">
              <b>Line Total</b>
            </th>
            <th class="table__actions"></th>
          </tr>
        </thead>
        <tbody
          id="invoice-line-items"
          cdkDropList
          (cdkDropListDropped)="drop($event)"
          formArrayName="line_items"
        >
          <ng-container
            *ngFor="
              let item of sortedLineItemsFormArray.controls
                | filterControls: searchableFields : searchStr;
              trackBy: trackByControlValue;
              let i = index
            "
          >
            <tr
              *ngIf="
                item.value.row_type !== eLineItemRowType.SUB_TOTAL;
                else subtotalRow
              "
              cdkDrag
              cdkDragLockAxis="y"
              [formGroupName]="i"
              id="row-invoice{{ i }}"
              [lumTableAnimateRow]="item.value.sku"
            >
              <td>
                <mat-checkbox
                  [lumKeyPressLineItems]="{
                    columnKey: 0,
                    rowKey: i,
                    parentId: 'invoice-line-items',
                    rowClass: 'row-invoice' + i,
                  }"
                  class="lum-checkbox"
                  formControlName="selected"
                ></mat-checkbox>
              </td>
              <td>
                <lum-ui-icon
                  cdkDragHandle
                  class="mr-2 cursor-grab"
                  icon="menu"
                  color="#36363A"
                ></lum-ui-icon>
              </td>
              <td *ngIf="displayColumns['sku'].visible">
                <div class="table__product-sku">
                  {{ item.value.sku }}
                </div>
              </td>
              <td *ngIf="displayColumns['product_name'].visible">
                <div class="w-99">
                  <input
                    [readonly]="form?.value?.autoPushUpdatesToSalesOrder && isSalesOrderShippedStatus"
                    [matAutocomplete]="auto"
                    (debounceValue)="onSearchRfq($event)"
                    (keyup.enter)="onEnterRfq($event, item, i)"
                    formControlName="product"
                    type="text"
                    class="lum-input table__search-skus-input"
                    placeholder="Search SKU or Product Name..."
                    matInput
                    id="id-{{ item.value.item_id }}"
                    #inputRef
                    [lumKeyPressLineItems]="{
                      columnKey: 1,
                      rowKey: i,
                      parentId: 'invoice-line-items',
                      rowClass: 'row-invoice' + i,
                    }"
                    lumDebounceTime
                  />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    class="rfq-item-autocomplete"
                    [panelWidth]="500"
                    [displayWith]="displayFnRfq"
                    [autoActiveFirstOption]="true"
                    (optionSelected)="onSelectSku($event, item.value.item_id)"
                    (lumInfiniteScroll)="scrollPaginate.emit($event)"
                  >
                    <ng-container *ngIf="!fromEnterEvent">
                      <ng-container *ngIf="!loadingRfqs; else loader">
                        <mat-option
                          *ngFor="let rfq of rfqs; trackBy: trackById"
                          [value]="rfq"
                          class="rfq-item-option"
                        >
                          <div class="rfq-item flex gap-4 w-100">
                            <div class="flex align-items-center">
                              <img
                                [lumRfqThumbnailUrl]="rfq"
                                alt=""
                                class="lum-img lum-thumbnail"
                              />
                            </div>

                            <div>
                              <div>
                                {{ rfq?.product_name }} [{{
                                  rfq?.sku ? rfq?.sku : 'N/A'
                                }}]
                              </div>
                              <small>
                                {{ rfq?.product_name }}
                              </small>
                            </div>
                          </div>
                        </mat-option>
                      </ng-container>
                    </ng-container>

                    <ng-template #loader>
                      <mat-option>
                        <div class="flex gap-4">
                          <mat-progress-spinner
                            class="progress-spinner mt-3"
                            diameter="24"
                            mode="indeterminate"
                          ></mat-progress-spinner>
                          <small>Loading...</small>
                        </div>
                      </mat-option>
                    </ng-template>
                  </mat-autocomplete>
                </div>
              </td>
              <td *ngIf="displayColumns['description'].visible">
                <input
                  [readonly]="!item.value.sku"
                  [lumKeyPressLineItems]="{
                    columnKey: 2,
                    rowKey: i,
                    parentId: 'invoice-line-items',
                    rowClass: 'row-invoice' + i,
                  }"
                  formControlName="description"
                  type="text"
                  class="lum-input w-75"
                  matInput
                />
              </td>
              <td *ngIf="displayColumns['category'].visible">
                {{ item.value.category?.product_category }}
              </td>
              <td
                *ngIf="displayColumns['sub_category'].visible"
                class="expanded-cell sub_category"
              >
                {{ item.value.subcategory?.sub_category }}
              </td>
              <td *ngIf="displayColumns['stock'].visible">
                <lum-rfq-status
                  *ngIf="item.value.sku"
                  [item]="item.value"
                ></lum-rfq-status>
              </td>
              <td
                *ngIf="displayColumns['quantity'].visible"
                class="flex justify-content-end"
              >
                <input
                  [readonly]="!item.value.sku || (form?.value?.autoPushUpdatesToSalesOrder && isSalesOrderShippedStatus)"
                  formControlName="quantity"
                  type="number"
                  inputmode="numeric"
                  class="lum-input text-right w-30"
                  matInput
                  lumPreventScroll
                  lumDecimalLimit
                  [lumKeyPressLineItems]="{
                    columnKey: 3,
                    rowKey: i,
                    parentId: 'invoice-line-items',
                    rowClass: 'row-invoice' + i,
                  }"
                />
              </td>
              <td *ngIf="displayColumns['unit'].visible">
                <mat-select
                  *ngIf="item.value.type !== 'KIT'"
                  [disabled]="!item.value.sku || (form?.value?.autoPushUpdatesToSalesOrder && isSalesOrderShippedStatus)"
                  formControlName="ordered_uom_id"
                  class="lum-select w-50"
                  [lumKeyPressLineItems]="{
                    columnKey: 4,
                    rowKey: i,
                    parentId: 'invoice-line-items',
                    rowClass: 'row-invoice' + i,
                  }"
                >
                  <mat-option
                    *ngFor="
                      let unitOfMeassure of item.value.unit_of_measures;
                      trackBy: trackById
                    "
                    [value]="unitOfMeassure.id"
                  >
                    {{ unitOfMeassure.name }}
                  </mat-option>
                </mat-select>
              </td>
              <td *ngIf="displayColumns['unit_price'].visible">
                <div class="flex justify-content-end">
                  <input
                    [readonly]="!isOverride"
                    [disabled]="!item.value.sku"
                    formControlName="unit_price"
                    type="number"
                    inputmode="numeric"
                    class="lum-input text-right w-30 quantity-input"
                    matInput
                    lumPreventScroll
                    [lumKeyPressLineItems]="{
                      columnKey: 5,
                      rowKey: i,
                      parentId: 'invoice-line-items',
                      rowClass: 'row-invoice' + i,
                    }"
                  />
                </div>
              </td>
              <td *ngIf="isOverride" class="flex justify-content-end">
                <input
                  formControlName="discount_amount"
                  type="number"
                  inputmode="numeric"
                  class="lum-input text-right w-30"
                  matInput
                  lumPreventScroll
                  [lumKeyPressLineItems]="{
                    columnKey: 6,
                    rowKey: i,
                    parentId: 'invoice-line-items',
                    rowClass: 'row-invoice' + i,
                  }"
                />
              </td>
              <td *ngIf="isOverride">
                <div class="flex justify-content-end">
                  <input
                    formControlName="discount_percent"
                    type="number"
                    inputmode="numeric"
                    class="lum-input text-right w-30"
                    matInput
                    lumPreventScroll
                    [lumKeyPressLineItems]="{
                      columnKey: 7,
                      rowKey: i,
                      parentId: 'invoice-line-items',
                      rowClass: 'row-invoice' + i,
                    }"
                  />
                </div>
              </td>
              <td *ngIf="displayColumns['line_total'].visible">
                <div class="text-right table__data-quantity">
                  {{ item.value.net_total_amount | decimalPlaces }}
                </div>
              </td>
              <td class="table__actions flex justify-end">
                <button
                  *ngIf="item.value.sku"
                  mat-icon-button
                  type="button"
                  (click)="onAddSubtotalRow(i)"
                >
                  <i
                    class="fa fa-calculator text-gray-600"
                    [matTooltip]="'Calculate sub total'"
                  ></i>
                </button>
                <button
                  [disabled]="form?.value?.autoPushUpdatesToSalesOrder && isSalesOrderShippedStatus"
                  mat-icon-button
                  type="button"
                  (click)="onRemoveLineItem(i)"
                >
                  <lum-ui-icon
                    icon="delete-bin"
                    [width]="16"
                    [height]="16"
                    color="#f24f63"
                  ></lum-ui-icon>
                </button>
              </td>
            </tr>
            <ng-template #subtotalRow>
              <tr [@slideInAnimation]>
                <td colspan="6"></td>
                <td colspan="8" class="sublines">
                  <div class="flex justify-end">
                    <div class="mr-2">
                      <strong>Total Units: </strong>
                      {{ item.value.quantity | decimalPlaces }}
                    </div>
                    <div class="">
                      <strong>Sub Total: </strong>
                      {{ item.value.net_total_amount | lumCurrency }}
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="mt-4">
      <button
        [disabled]="form?.value?.autoPushUpdatesToSalesOrder && isSalesOrderShippedStatus"
        [matMenuTriggerFor]="menu"
        class="lum-button"
        type="button"
        mat-button
      >
        <lum-ui-icon
          width="10"
          height="10"
          class="mr-2"
          icon="add-circle"
        ></lum-ui-icon>
        Add Row(s)
      </button>
      <mat-menu class="lum-mat-menu" #menu="matMenu">
        <button (click)="addRowItems.emit(1)" mat-menu-item type="button">
          Add 1 Item
        </button>
        <button (click)="addRowItems.emit(5)" mat-menu-item type="button">
          Add 5 Items
        </button>
        <button (click)="addRowItems.emit(10)" mat-menu-item type="button">
          Add 10 Items
        </button>
        <button (click)="addRowItems.emit(25)" mat-menu-item type="button">
          Add 25 Items
        </button>
        <button (click)="addRowItems.emit(50)" mat-menu-item type="button">
          Add 50 Items
        </button>
      </mat-menu>
    </div>
  </form>
</div>
